import styled from 'styled-components';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
const StyledPillContainer = styled(ToggleButtonGroup)`
  && {
    margin: 10px;
    height: 26px;
  }
`;
export default StyledPillContainer;